import QRCode from "qrcode";

/**
 * Build a data-URL QR image for any share link (no external API).
 */
export async function buildQrDataUrl(text, size = 400) {
  const value = String(text || "").trim();
  if (!value) {
    throw new Error("A URL is required to generate a QR code.");
  }
  return QRCode.toDataURL(value, {
    width: size,
    margin: 2,
    errorCorrectionLevel: "M",
  });
}
